// import React from "react";
// import { useEffect, useState } from "react";
// import {
//   Box, Typography, CircularProgress, Alert, Stack, Button, Pagination,
//   FormControl, Select, MenuItem,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { fetchSavedJobs } from "../api/jobsApi";
// import { clearAuth, getUser } from "../utils/auth";
// import { ACCENT } from "../components/DashboardLayout";
// import SourceChip from "../components/SourceChip";
// import SavedJobCard from "../components/SavedJobCard";
// import SavedJobsFilterBar from "../components/SavedJobsFilterBar";

// const PAGE_SIZE_OPTIONS = [5, 10, 20];
// const DEFAULT_PAGE_SIZE = 10;

// const ROLE_LABELS = {
//   ADMIN: 'Admin',
//   TEAM_LEAD: 'Team Lead',
//   RECRUITER: 'Recruiter',
// };

// const ROLE_HOME_ROUTES = {
//   ADMIN: '/admin',
//   TEAM_LEAD: '/team-lead/home',
//   RECRUITER: '/recruiter/home',
// };

// export default function SavedJobsView() {
//   const navigate = useNavigate();
//   const user = getUser();

//   const [jobs, setJobs] = useState([]);
//   const [filters, setFilters] = useState({});
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCount, setTotalCount] = useState(0);
//   const [sourceBreakdown, setSourceBreakdown] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const loadJobs = async (targetPage, targetPageSize, targetFilters) => {
//     setLoading(true);
//     setError("");
//     try {
//       const data = await fetchSavedJobs(targetPage, targetPageSize, targetFilters);
//       setJobs(data.jobs);
//       setTotalPages(data.totalPages);
//       setTotalCount(data.totalCount);
//       setSourceBreakdown(data.sourceBreakdown || {});
//     } catch (err) {
//       setError("Could not load jobs. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadJobs(1, DEFAULT_PAGE_SIZE, {});
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const handleApplyFilters = (appliedFilters) => {
//     setFilters(appliedFilters);
//     setPage(1);
//     loadJobs(1, pageSize, appliedFilters);
//   };

//   const handlePageChange = (event, value) => {
//     setPage(value);
//     loadJobs(value, pageSize, filters);
//   };

//   const handlePageSizeChange = (event) => {
//     const newSize = event.target.value;
//     setPageSize(newSize);
//     setPage(1);
//     loadJobs(1, newSize, filters);
//   };

//   const handleLogout = () => {
//     clearAuth();
//     navigate("/");
//   };

//   const roleLabel = ROLE_LABELS[user?.role] || 'User';

//   return (
//     <Box sx={{ maxWidth: "100%", mx: "auto", p: 3 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
//         <Box>
//           <Typography
//             sx={{
//               fontSize: 12,
//               fontWeight: 700,
//               letterSpacing: '1.2px',
//               color: ACCENT,
//               mb: 0.5,
//               textTransform: 'uppercase',
//             }}
//           >
//             {roleLabel}
//           </Typography>
//           <Typography
//             sx={{
//               fontFamily: "'Lora', serif",
//               fontWeight: 600,
//               fontSize: 26,
//               color: '#1B2430',
//               lineHeight: 1.2,
//             }}
//           >
//             Saved Jobs
//           </Typography>
//           <Typography variant="body2" sx={{ color: '#5B6472', mt: 0.5 }}>
//             {roleLabel} — {user?.email}
//           </Typography>
//         </Box>
//         <Stack direction="row" spacing={1.5}>
//           <Button
//             variant="outlined"
//             size="small"
//             onClick={() => navigate(ROLE_HOME_ROUTES[user?.role] || '/')}
//             sx={{
//               color: '#16324F',
//               borderColor: '#C9CDD4',
//               '&:hover': { borderColor: '#16324F', background: '#F2F4F6' },
//             }}
//           >
//             ← Back to Home
//           </Button>
//           <Button
//             variant="outlined"
//             size="small"
//             onClick={handleLogout}
//             sx={{
//               color: '#16324F',
//               borderColor: '#C9CDD4',
//               '&:hover': { borderColor: '#16324F', background: '#F2F4F6' },
//             }}
//           >
//             Log Out
//           </Button>
//         </Stack>
//       </Box>

//       <SavedJobsFilterBar onApply={handleApplyFilters} />

//       {error && <Alert severity="error">{error}</Alert>}

//       <Box
//         sx={{
//           display: "flex",
//           width: "100%",
//           justifyContent: "space-between",
//           alignItems: "center",
//           flexWrap: "wrap",
//           rowGap: 1.5,
//           mb: 2,
//         }}
//       >
//         <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ rowGap: 1 }}>
//           <Typography variant="body2" fontWeight={600} color="text.primary">
//             {totalCount} job{totalCount === 1 ? "" : "s"} found
//           </Typography>
//           {Object.entries(sourceBreakdown).map(([source, count]) => (
//             <SourceChip key={source} source={source} count={count} />
//           ))}
//         </Stack>

//         <Stack direction="row" spacing={2} alignItems="center">
//           <FormControl size="small" sx={{ minWidth: 120 }}>
//             <Select value={pageSize} onChange={handlePageSizeChange} sx={{ fontSize: 13, height: 30 }}>
//               {PAGE_SIZE_OPTIONS.map((size) => (
//                 <MenuItem key={size} value={size}>{size} per page</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {totalPages > 1 && (
//             <Pagination
//               count={totalPages}
//               page={page}
//               onChange={handlePageChange}
//               color="primary"
//               size="small"
//             />
//           )}
//         </Stack>
//       </Box>

//       {loading && <CircularProgress size={28} />}

//       {!loading && !error && jobs.length === 0 && (
//         <Typography color="text.secondary">No jobs matched these filters.</Typography>
//       )}

//       {!loading && !error && jobs.map((job) => (
//         <SavedJobCard key={job._id} job={job} />
//       ))}
//     </Box>
//   );
// }

import React from "react";
import { useEffect, useState } from "react";
import {
  Box, Typography, CircularProgress, Alert, Stack, Button, Pagination,
  FormControl, Select, MenuItem,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { fetchSavedJobs } from "../api/jobsApi";
import { clearAuth, getUser } from "../utils/auth";
import { ACCENT } from "../components/DashboardLayout";
import SourceChip from "../components/SourceChip";
import SavedJobCard from "../components/SavedJobCard";
import SavedJobsFilterBar from "../components/SavedJobsFilterBar";

const PAGE_SIZE_OPTIONS = [5, 10, 20];
const DEFAULT_PAGE_SIZE = 10;

const ROLE_LABELS = {
  ADMIN: 'Admin',
  TEAM_LEAD: 'Team Lead',
  RECRUITER: 'Recruiter',
};

const ROLE_HOME_ROUTES = {
  ADMIN: '/admin',
  TEAM_LEAD: '/team-lead/home',
  RECRUITER: '/recruiter/home',
};

export default function SavedJobsView() {
  const navigate = useNavigate();
  const user = getUser();

  const [jobs, setJobs] = useState([]);
  const [filters, setFilters] = useState({});
  const [sourceFilter, setSourceFilter] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sourceBreakdown, setSourceBreakdown] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadJobs = async (targetPage, targetPageSize, targetFilters) => {
    setLoading(true);
    setError("");
    try {
      const data = await fetchSavedJobs(targetPage, targetPageSize, targetFilters);
      setJobs(data.jobs);
      setTotalPages(data.totalPages);
      setTotalCount(data.totalCount);
      setSourceBreakdown(data.sourceBreakdown || {});
    } catch (err) {
      setError("Could not load jobs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadJobs(1, DEFAULT_PAGE_SIZE, {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    setPage(1);
    // A fresh filter-bar search starts over — any active source-chip filter is cleared,
    // since the person is defining a new search from scratch, not refining the current one.
    setSourceFilter('');
    loadJobs(1, pageSize, appliedFilters);
  };

  // Clicking the currently-active chip again clears the source filter (toggle off);
  // clicking a different chip switches to that source instead. Source-breakdown counts in
  // sourceBreakdown are computed over the full filtered set (before this click), so they
  // stay stable and clickable even while one source is currently selected.
  const handleSourceChipClick = (source) => {
    const nextSource = sourceFilter === source ? '' : source;
    setSourceFilter(nextSource);
    setPage(1);
    loadJobs(1, pageSize, { ...filters, source: nextSource });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    loadJobs(value, pageSize, { ...filters, source: sourceFilter });
  };

  const handlePageSizeChange = (event) => {
    const newSize = event.target.value;
    setPageSize(newSize);
    setPage(1);
    loadJobs(1, newSize, { ...filters, source: sourceFilter });
  };

  const handleLogout = () => {
    clearAuth();
    navigate("/");
  };

  const roleLabel = ROLE_LABELS[user?.role] || 'User';

  return (
    <Box sx={{ maxWidth: "100%", mx: "auto", p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
        <Box>
          <Typography
            sx={{
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '1.2px',
              color: ACCENT,
              mb: 0.5,
              textTransform: 'uppercase',
            }}
          >
            {roleLabel}
          </Typography>
          <Typography
            sx={{
              fontFamily: "'Lora', serif",
              fontWeight: 600,
              fontSize: 26,
              color: '#1B2430',
              lineHeight: 1.2,
            }}
          >
            Saved Jobs
          </Typography>
          <Typography variant="body2" sx={{ color: '#5B6472', mt: 0.5 }}>
            {roleLabel} — {user?.email}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1.5}>
          <Button
            variant="outlined"
            size="small"
            onClick={() => navigate(ROLE_HOME_ROUTES[user?.role] || '/')}
            sx={{
              color: '#16324F',
              borderColor: '#C9CDD4',
              '&:hover': { borderColor: '#16324F', background: '#F2F4F6' },
            }}
          >
            ← Back to Home
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={handleLogout}
            sx={{
              color: '#16324F',
              borderColor: '#C9CDD4',
              '&:hover': { borderColor: '#16324F', background: '#F2F4F6' },
            }}
          >
            Log Out
          </Button>
        </Stack>
      </Box>

      <SavedJobsFilterBar onApply={handleApplyFilters} />

      {error && <Alert severity="error">{error}</Alert>}

      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          rowGap: 1.5,
          mb: 2,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" sx={{ rowGap: 1 }}>
          <Typography variant="body2" fontWeight={600} color="text.primary">
            {totalCount} job{totalCount === 1 ? "" : "s"} found
          </Typography>
          {Object.entries(sourceBreakdown).map(([source, count]) => (
            <SourceChip
              key={source}
              source={source}
              count={count}
              active={sourceFilter === source}
              onClick={() => handleSourceChipClick(source)}
            />
          ))}
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select value={pageSize} onChange={handlePageSizeChange} sx={{ fontSize: 13, height: 30 }}>
              {PAGE_SIZE_OPTIONS.map((size) => (
                <MenuItem key={size} value={size}>{size} per page</MenuItem>
              ))}
            </Select>
          </FormControl>

          {totalPages > 1 && (
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
              size="small"
            />
          )}
        </Stack>
      </Box>

      {loading && <CircularProgress size={28} />}

      {!loading && !error && jobs.length === 0 && (
        <Typography color="text.secondary">No jobs matched these filters.</Typography>
      )}

      {!loading && !error && jobs.map((job) => (
        <SavedJobCard key={job._id} job={job} />
      ))}
    </Box>
  );
}